import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "jds_cross",
  "use": "jds_cross-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"jds_cross\">\n  <path fill-rule=\"evenodd\" d=\"M5.152 5.151a1.2 1.2 0 0 1 1.697 0L12 10.303l5.151-5.152A1.2 1.2 0 0 1 18.85 6.85L13.697 12l5.152 5.151a1.2 1.2 0 1 1-1.698 1.698L12 13.697l-5.151 5.152a1.2 1.2 0 0 1-1.697-1.698L10.303 12 5.152 6.849a1.2 1.2 0 0 1 0-1.698Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol